import PropTypes from "prop-types";

export default PropTypes.shape({
  title: PropTypes.string,
  location: PropTypes.string,
  placement_fee: PropTypes.string,
  salary_min: PropTypes.string,
  sector_id: PropTypes.string,
  description: PropTypes.string,
  feedback_timescale: PropTypes.string,
  notification_recipient_ids: PropTypes.string,
});
